var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.8C7 6.08203 6.32843 5.5 5.5 5.5C4.67157 5.5 4 6.08203 4 6.8V17.2C4 17.918 4.67157 18.5 5.5 18.5C6.32843 18.5 7 17.918 7 17.2V6.8Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.8C20 6.08203 19.3284 5.5 18.5 5.5C17.6716 5.5 17 6.08203 17 6.8V17.2C17 17.918 17.6716 18.5 18.5 18.5C19.3284 18.5 20 17.918 20 17.2V6.8Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.33333C4 8.59695 3.32843 8 2.5 8C1.67157 8 1 8.59695 1 9.33333V14.6667C1 15.403 1.67157 16 2.5 16C3.32843 16 4 15.403 4 14.6667V9.33333Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.33333C23 8.59695 22.3284 8 21.5 8C20.6716 8 20 8.59695 20 9.33333V14.6667C20 15.403 20.6716 16 21.5 16C22.3284 16 23 15.403 23 14.6667V9.33333Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    transform: "matrix(1 0 0 -1 7 13.5)",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.979718b943d7d64aa3997e53f49918d0.svg";
export { ForwardRef as ReactComponent };